export default "__VITE_ASSET__BBua9Hhh__"